define('components/transition/transition',[], function () {
    "use strict";

    var Transition = {
        "Direction": {
            "DOWN": "Down",
            "LEFT": "Left",
            "NONE": "",
            "RIGHT": "Right",
            "UP": "Up"
        },

        "Type": {
            "BOUNCE": null,
            "BOUNCE_IN": null,
            "FADE": null,
            "FADE_IN": null,
            "FADE_OUT": null,
            "FLASH": null,
            "JELLO": null,
            "PULSE": null,
            "RUBBER_BAND": null,
            "SHAKE": null,
            "SLIDE_IN": null,
            "SLIDE_OUT": null,
            "SWING": null,
            "TADA": null,
            "WOGGLE": null
        },

        "create": function (opts) {
            var deferred = new $.Deferred(),
                defaults = {
                    "delay": null,
                    "direction": Transition.Direction.NONE,
                    "duration": null,
                    "context": deferred,
                    "el": 'div',
                    "iterationCount": null,
                    "type": Transition.Type.FADE_IN
                };

            deferred = _.extend(deferred, defaults, opts);

            deferred.start = function () {
                deferred.el = $(deferred.el);
                deferred.infinite = deferred.iterationCount === 'infinite';
                deferred.animatedClass = 'animated ' + deferred.type + deferred.direction;

                deferred.el.css({
                            "-webkit-animation-duration": deferred.duration ? deferred.duration + "s" : "",
                            "-webkit-animation-delay": deferred.delay ? deferred.delay + "s" : "",
                            "-webkit-animation-iteration-count": deferred.iterationCount ? deferred.iterationCount.toString() : "",
                            "animation-duration": deferred.duration ? deferred.duration + "s" : "",
                            "animation-delay": deferred.delay ? deferred.delay + "s" : "",
                            "animation-iteration-count": deferred.iterationCount ? deferred.iterationCount.toString() : ""
                        })
                        .addClass(deferred.animatedClass);

                // This event is NOT triggered for infinite animation.
                // The implication of this is that the deferred object is NOT resolved unless
                // the animation iteration count is set to a finite value.
                deferred.el.one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function () {
                    deferred.el.removeClass(deferred.animatedClass)
                            .css({
                                "-webkit-animation-duration": "",
                                "-webkit-animation-delay": "",
                                "-webkit-animation-iteration-count": "",
                                "animation-duration": "",
                                "animation-delay": "",
                                "animation-iteration-count": ""
                            });

                    deferred.resolveWith(deferred.context, [deferred]);
                });
            };

            return deferred;
        }
    };

    _.each(Transition.Type, function (value, key, Type) {
        var parts = key.split('_');
        _.each(parts, function (part, index) {
            if (index === 0) {
                parts[index] = part.toLowerCase();
            } else {
                parts[index] = part[0].toUpperCase() + part.substring(1).toLowerCase();
            }
        });

        Type[key] = parts.join("");
    });

    return Transition;
});

